export default __webpack_public_path__ + "static/media/whitepaper.78c6bc14.pdf";